// @flow
import type {
  ComposeDataTableArgs,
  ActionTypes,
} from '../../types'

import {
  prefix,
  PAGINATE,
  SELECT,
  SELECT_ALL,
  FILTER,
  SORT,
  GROUP,
  ORDER,
  RESET_DATA_TABLE_STATE,
} from './constants'

// Exports
export default function composeActionTypes ({
  name,
  options,
  }: ComposeDataTableArgs): ActionTypes {
  //
  const {
    allowGrouping = false,
    allowColumnOrdering = false,
    allowSelecting = true,
    allowSorting = true,
    allowFiltering = true,
    allowPagination = true,
    allowSelectAll = true,
  } = options

  const actionTypes = {}

  if (allowPagination) {
    actionTypes.paginate = `${prefix}/${name.toLowerCase()}/${PAGINATE}`
  }

  if (allowSorting) {
    actionTypes.sort = `${prefix}/${name.toLowerCase()}/${SORT}`
  }

  if (allowGrouping) {
    actionTypes.group = `${prefix}/${name.toLowerCase()}/${GROUP}`
  }

  if (allowFiltering) {
    actionTypes.filter = `${prefix}/${name.toLowerCase()}/${FILTER}`
  }

  if (allowSelecting) {
    actionTypes.select = `${prefix}/${name.toLowerCase()}/${SELECT}`
  }

  if (allowColumnOrdering) {
    actionTypes.order = `${prefix}/${name.toLowerCase()}/${ORDER}`
  }

  if (allowSelectAll) {
    actionTypes.selectAll = `${prefix}/${name.toLowerCase()}/${SELECT_ALL}`
  }

  actionTypes.resetDataTableState = `${prefix}/${name.toLowerCase()}/${RESET_DATA_TABLE_STATE}`

  return actionTypes
}
